import React, { memo } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  LabelList
} from 'recharts';

interface ChartDataItem {
  name: string;
  value: number;
  percentage: number;
}

interface ChartProps {
  data: ChartDataItem[];
}

const CustomBarLabel = memo(({ x, y, width, value, data }: any) => {
  const percentage = data.find((item: any) => item.value === value)?.percentage;
  return (
    <text
      x={x + width}
      y={y + 20}
      className="tw-fill-black"
      fontSize={12}
      textAnchor="start"
      dominantBaseline="middle"
    >
      — {value} ({percentage}%)
    </text>
  );
});

CustomBarLabel.displayName = 'CustomBarLabel';

const CustomYAxisTick = memo(({ y, payload }: any) => {
  return (
    <text
      x={0}
      y={y}
      dy={4}
      className="tw-fill-black"
      fontSize={12}
      textAnchor="start"
      dominantBaseline="middle"
    >
      <title>{payload.value}</title>
      {payload.value.length > 20 ? `${payload.value.slice(0, 20)}...` : payload.value}
    </text>
  );
});

CustomYAxisTick.displayName = 'CustomYAxisTick';

export const HorizontalBarChart = memo(({ data }: ChartProps) => {
  const roundedMaxDomain = Math.ceil(Math.max(...data.map((item) => item.value)) * 1.3);
  return (
    <ResponsiveContainer width="100%">
      <BarChart data={data} layout="vertical" margin={{ bottom: -10 }}>
        <CartesianGrid horizontal={false} className="tw-stroke-border-grey" />
        <XAxis
          type="number"
          domain={[0, roundedMaxDomain]}
          allowDecimals={false}
          tick={{ fontSize: 12 }}
          tickLine={false}
        />
        <YAxis
          type="category"
          dataKey="name"
          width={80}
          tickLine={false}
          tick={<CustomYAxisTick />}
          padding={{ top: 5, bottom: 15 }}
        />
        <Bar dataKey="value" className="tw-fill-primary-blue" maxBarSize={40}>
          <LabelList dataKey="value" content={<CustomBarLabel data={data} />} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
});

HorizontalBarChart.displayName = 'HorizontalBarChart';
